module.exports = __webpack_public_path__ + "img/2025-03_experiential-learning.cfa15b5a.webp";